import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../appstate';
import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {DeviceInfo} from '../../data/device-info';
/**
 * Created by ashok on 10/05/17.
 */
@Injectable()
export class DeviceDataService {

    constructor(private store: Store<AppState>){}

    public getDeviceInfo(): Observable<DeviceInfo> {
        return this.store.select((appState:any)=>appState.reducers.deviceInfo).pipe(filter(Boolean));
    }
    public getDeviceId(): Observable<string> {
        return this.store.select((appState:any)=>appState.reducers.deviceInfo.deviceId).pipe(filter(Boolean));
    }
}